import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackIntegrationEvent = createAnalyticsTracker('integrationV2');
